import React, { useEffect, useState } from "react";
import {
  Image,
  Platform,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
  ScrollView,
} from "react-native";

import { StackActions } from "@react-navigation/native";
import BackgroundUser from "../components/BackgroundUser";
import Title from "../components/Title";
import Logo from "../components/Logo";
import InputLayout from "../components/InputLayout";
import ButtonLayout from "../components/ButtonLayout";
import ButtonLayoutMenu from "../components/ButtonLayoutMenu";
import makeRequest from "../components/makeRequest";

export default function (props) {
  const [password, setPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [failed, setFailed] = useState(false);
  const [failedMessage, setFailedMessage] = useState("");
  return (
    <BackgroundUser scroll={true}>
      <Logo></Logo>
      <View style={{ marginTop: 20 }}>
        <Title>Cambio de contraseña</Title>
        <InputLayout
          placeholder='Nueva contraseña'
          value={password}
          onChangeText={setPassword}
          secureTextEntry={true}
        />
        <InputLayout
          placeholder='Repita la nueva contraseña'
          value={repeatPassword}
          onChangeText={setRepeatPassword}
          secureTextEntry={true}
        />
        {failed && (
          <Title style={{ fontSize: 15, color: "red" }}>{failedMessage}</Title>
        )}
        <ButtonLayout
          text='Modificar contaseña'
          onPress={async () => {
            if (password.trim() == "") {
              setFailed(true);
              setFailedMessage(
                "Es obligatorio especificar la nueva contraseña"
              );
              return;
            }
            if (password != repeatPassword) {
              setFailed(true);
              setFailedMessage("Las contraseñas no coinciden");
              setRepeatPassword("");
              return;
            }
            const response = await makeRequest("users/password", "put", {
              password: password,
            });
            if (response[0] == 200) props.navigation.goBack();
            else {
              setFailed(true);
              setFailedMessage("Ha ocurrido un error desconocido");
            }
          }}></ButtonLayout>
        <ButtonLayoutMenu
          text='Cancelar'
          style={{ maxWidth: 150, alignSelf: "center" }}
          onPress={() => props.navigation.goBack()}></ButtonLayoutMenu>
      </View>
    </BackgroundUser>
  );
}
